export default __webpack_public_path__ + "static/subset-Inter-Regular-763cd48193bd4825288ea16aad3f9574.woff";